import { render, staticRenderFns } from "./settings-organization-sso.vue?vue&type=template&id=e6685578&scoped=true&"
import script from "./settings-organization-sso.vue?vue&type=script&lang=js&"
export * from "./settings-organization-sso.vue?vue&type=script&lang=js&"
import style0 from "./settings-organization-sso.vue?vue&type=style&index=0&id=e6685578&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6685578",
  null
  
)

export default component.exports